class ModelList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach(el => {
        this.listeners.add(el, 'click', this.handleTrigger)
      })
    }

    if (this.els?.filter?.exists) {
      this.handleFilter = this.handleFilter.bind(this)

      this.els.filter.elements.forEach(filterEl => {
        this.listeners.add(filterEl, `click`, this.handleFilter)
      })
    }

    window.addEventListener('popstate', () => this.syncButtonStatesFromUrl())
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach(panelEl => {
      panelEl.ariaHidden = panelEl.dataset.tab !== triggerEl.dataset.tab
    })
    this.els.trigger.elements.forEach(trigger => {
      trigger.ariaPressed = trigger.dataset.tab === triggerEl.dataset.tab
    })
  }

  syncButtonStatesFromUrl () {
    if (!this.els?.filter?.exists) return

    const params = new URLSearchParams(window.location.search)

    this.els.filter.elements.forEach(filterEl => {
      const filterCategory = filterEl.dataset.filterCategory
      const filterValue = filterEl.dataset.filterValue
      if (!filterCategory || !filterValue) return

      filterEl.ariaPressed = params.getAll(filterCategory).includes(filterValue)
        ? 'true'
        : 'false'
    })
  }

  isOmetriaActive () {
    return (
      typeof window.graphenehc?.load === 'function' &&
      document.querySelector('#collection-page-product-grid') !== null
    )
  }

  findDrawerCheckbox (drawer, filterValue) {
    const lower = filterValue.toLowerCase()
    const handle = lower.replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')

    const checkboxes = drawer.querySelectorAll(
      'input[type="checkbox"].clc-ProductGridFacet_Checkbox',
    )

    for (const cb of checkboxes) {
      const cbVal = cb.value || ''
      const cbLower = cbVal.toLowerCase()
      const cbHandle = cbLower.replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')

      if (cbVal === filterValue || cbLower === lower || cbHandle === handle) {
        return cb
      }
    }

    const items = drawer.querySelectorAll(
      '.clc-ProductGridFacet_Item[data-filter-value]',
    )
    for (const item of items) {
      const dv = (item.dataset.filterValue || '').toLowerCase()
      if (dv === lower) {
        const cb = item.querySelector('input[type="checkbox"]')
        if (cb) return cb
      }
    }

    return null
  }

  handleFilter (event) {
    const filterEl = event.target.closest(this.els?.filter?.selector)
    if (!filterEl) return

    if (this.isOmetriaActive()) {
      event.stopPropagation()

      const filterValue = filterEl.dataset.filterValue
      if (!filterValue) return

      const drawer = document.querySelector(
        'site-drawer[key="collection-filters"]',
      )

      if (drawer && window.ometriaFacetSync?.buildUrlFromDrawer) {
        const checkbox = this.findDrawerCheckbox(drawer, filterValue)

        if (checkbox) {
          checkbox.checked = !checkbox.checked
          filterEl.ariaPressed = checkbox.checked ? 'true' : 'false'

          const url = window.ometriaFacetSync.buildUrlFromDrawer(
            drawer,
            checkbox.name,
          )
          window.ometriaFacetSync.refreshGridWith(url)
          return
        }
      }

      const filterCategory = filterEl.dataset.filterCategory
      if (!filterCategory) return

      const url = new URL(window.location.href)
      const params = url.searchParams
      params.delete('page')

      const currentValues = params.getAll(filterCategory)
      const isActive = currentValues.includes(filterValue)

      if (isActive) {
        const remaining = currentValues.filter(v => v !== filterValue)
        params.delete(filterCategory)
        remaining.forEach(v => params.append(filterCategory, v))
        filterEl.ariaPressed = 'false'
      } else {
        params.append(filterCategory, filterValue)
        filterEl.ariaPressed = 'true'
      }

      window.location.href = url.toString()
      return
    }

    filterEl.ariaPressed = filterEl.ariaPressed === 'true' ? 'false' : 'true'
  }
}

if (!customElements.get('model-list')) {
  customElements.define('model-list', ModelList)
}
